<template>
    <div class="popup" v-show="show">
        <div class="doorDetail bg_white">
            <Icon class="closer cursor_pointer" type="md-close" @click="show=false" size="26"/>
            <div class="title f18 bold500 txt_black87 tc" v-if="flag==='create'">新建柜门</div>
            <div class="title f18 bold500 txt_black87 tc" v-if="flag==='edit'">编辑柜门</div>
            <div class="content f14 txt_black85 bold500">
                <div class=" item txt_black54 f14 bold500">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        柜门编号：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" placeholder="请输入柜门编号" v-model="data.no"/>
                    </div>
                </div>

                <div class=" item txt_black54 f14 bold500">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        柜门型号：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" placeholder="请输入柜门型号" v-model="data.type"/>
<!--                        <selection :options="$config.doorType.getItem(1)"></selection>-->
                    </div>
                </div>

                <div class=" item txt_black54 f14 bold500">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        板卡ID：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" placeholder="请输入板卡ID"  v-model="data.cid"/>
                    </div>
                </div>

                <div class=" item txt_black54 f14 bold500">
                    <div class="title bold600 content-center">
                        <Icon type="ios-star"/>
                        通道ID：
                    </div>
                    <div class="ipt">
                        <input class="w100 h100" type="text" placeholder="请输入通道ID"  v-model="data.ch"/>
                    </div>
                </div>
            </div>

            <div class="submit tc">
                <button class="bg_E91E63 f18 bold400 txt_white tc cursor_pointer" @click="submit">提交</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "doorDetail",
        data() {
            return {
                show: false,
                flag: 'create',
                data: {
                    no: '',
                    type: '',
                    cid: '',
                    ch: '',
                    id: '',
                    point_id: ''
                }
            }
        },
        methods: {
            init(flag,data) {
                this.show = true;
                this.flag = flag;
                for (let v in this.data) {
                    this.data[v] = data[v];
                }
            },
            submit() {
                if(this.flag === 'create') {
                    this.$api.post('/manage/door', this.data).then((data) => {
                        this.$alert.success({content: '新建成功'});
                        this.show = false;
                        this.$emit('updateData');
                    }).catch((error) => {
                        this.$alert.error({content: '新建失败，请重试'});
                    });
                }else {
                    this.$api.put('/manage/door/' + this.data.id, this.data).then((data) => {
                        this.$alert.success({content: '修改成功'});
                        this.show = false;
                        this.$emit('updateData');
                    }).catch((error) => {
                        this.$alert.error({content: '修改失败，请重试'});
                    });
                }
            }
        }
    }
</script>

<style scoped>
    .doorDetail {
        width: 400px;
        height: 500px;
    }

    .content {
        padding: 0 50px;
    }

    .content > .item {
        margin-top: 20px;
        width: 300px;
    }

    .content > .item > .ipt >:first-child {
        height: 36px;
        line-height: 36px;
        margin-top: 8px;
    }

    .content > .item > .ipt > input {
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 3px;
        padding: 0 10px;

    }
</style>